<div class="p-3">

  <p-inputGroup *ngIf="dialogData.branches" styleClass="border-[1px] border-solid border-[#ccc]">
    <p-inputGroupAddon>
      <i class="far fa-project-diagram"></i>
    </p-inputGroupAddon>
    <p-dropdown  [options]="dialogData.branches" optionLabel="branchName" optionValue="branchId" [(ngModel)]="selectedBranch" placeholder="Select branch"
      styleClass="w-full " />
  </p-inputGroup>


  <div class="flex justify-between my-2">
    <h1 class="text-[16px] font-semibold leading-[42px] text-[#141E27] ">{{dialogData.title}}</h1>
    <div>
      <h1 class="text-[16px] font-semibold leading-[42px] text-[#141E27] mb-[8px] inline">{{dialogData.currency}}
        {{dialogData.price}}</h1>
      <span *ngIf="dialogData.period" class="text-[14px] font-normal leading-[21px] text-[#141E27]"> / {{dialogData.period| translate}}</span>
    </div>
  </div>

  <h1 class="text-[16px] font-semibold leading-[36px] text-[#000]">Payment method</h1>

  <div class="mb-[20px] border-[1px] border-solid border-[#ccc]">

    <label class="border-b-[1px] border-solid border-[#ccc] flex items-start p-3 cursor-pointer hover:bg-[#f0f0f0]"
      for="Mada" [ngClass]="{'bg-[#0000002b] hover:bg-[#0000002b]': selectedPaymentMethod === PaymentMethod.Mada}">
      <p-radioButton [value]="PaymentMethod.Mada"[(ngModel)]="selectedPaymentMethod" inputId="Mada" />
      <div class="ms-3">
        <h1 class="mb-2">Mada</h1>
        <img src="../../../assets/mada.png" alt="MasterCard"
          class="w-[45px] h-[24px] object-contain inline-flex me-2" />
      </div>
    </label>

    <label class="border-b-[1px] border-solid border-[#ccc] flex items-start p-3 cursor-pointer hover:bg-[#f0f0f0]"
      for="MasterCard"
      [ngClass]="{'bg-[#0000002b] hover:bg-[#0000002b]': selectedPaymentMethod === PaymentMethod.MasterCard}">
      <p-radioButton [value]="PaymentMethod.MasterCard" [(ngModel)]="selectedPaymentMethod" inputId="MasterCard" />
      <div class="ms-3">
        <h1 class="mb-2">Credite or debit card</h1>
        <img src="../../../assets/visa-logo.png" alt="MasterCard"
          class="w-[45px] h-[24px] object-contain inline-flex me-2" />
        <img src="../../../assets/mastercard-logo.png" alt="MasterCard"
          class="w-[45px] h-[24px] object-contain inline-flex" />
      </div>
    </label>

    <label class="flex items-start p-3 cursor-pointer hover:bg-[#f0f0f0]" for="ApplePay"
      [ngClass]="{'bg-[#0000002b] hover:bg-[#0000002b]': selectedPaymentMethod === PaymentMethod.Applepay}">
      <p-radioButton [value]="PaymentMethod.Applepay" [(ngModel)]="selectedPaymentMethod" inputId="ApplePay" />
      <div class="ms-3">
        <h1 class="mb-2">Apple pay</h1>
        <img src="../../../assets/apple-pay-logo.png" alt="MasterCard"
          class="w-[45px] h-[24px] object-cover inline-flex" />
      </div>
    </label>

  </div>
</div>


<div class="w-full border-b-[1px] border-solid border-[#ccc] mt-3 "></div>

<div class="flex justify-center gap-2 my-3">
  <button
    class="bg-[#535353] text-[#fff] py-[8px] px-[16px] rounded-[8px] transform transition-all duration-300 hover:bg-[#d32f2f]"
    (click)="ref.close(false)">{{'Cancel'|translate}}</button>
  <button
    class="bg-[#694fd6] text-[#fff] py-[8px] px-[16px] rounded-[8px] transform transition-all duration-300 hover:bg-[#502ed6]"
    (click)="confirm()">{{'Submit'|translate}}</button>
</div>
